export function createProjectsApi(client) {
    return {
        list() {
            return client.get('/api/projects');
        },
        get(id) {
            return client.get(`/api/projects/${id}`);
        },
        create(id, content, message) {
            return client.post('/api/projects', message ? { id, content, message } : { id, content });
        },
        update(id, content, message) {
            return client.put(`/api/projects/${id}`, message ? { content, message } : { content });
        },
        remove(id) {
            return client.del(`/api/projects/${id}`);
        },
    };
}
//# sourceMappingURL=projects.js.map